import {
  AUTH_TOKEN_KEY,
  AUTH_USER_KEY,
  CatalogFallbackToken,
} from "./constants";

export const getStoredToken = () => localStorage.getItem(AUTH_TOKEN_KEY) || "";

export const getStoredUser = () => {
  try {
    const raw = localStorage.getItem(AUTH_USER_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
};

export const saveAuth = (token, user) => {
  if (token) localStorage.setItem(AUTH_TOKEN_KEY, token);
  if (user) localStorage.setItem(AUTH_USER_KEY, JSON.stringify(user));
};

export const clearAuth = () => {
  localStorage.removeItem(AUTH_TOKEN_KEY);
  localStorage.removeItem(AUTH_USER_KEY);
};

/** Prefer logged-in user token; fall back to catalog token for public browsing */
export const getAuthHeaderToken = (requireUser = false) => {
  const userToken = getStoredToken();
  if (userToken) return userToken;
  if (requireUser) return "";
  return CatalogFallbackToken;
};
